<template>
    <div v-if="protocol" >
        <v-menu
            transition="slide-y-transition"
            v-model = "open"
            min-width="400"
            :offset-overflow = "true"
            :max-height = "600"
            rounded
        >
            <template v-slot:activator="{ attrs, on }">
                <c-toolbar-button
                    v-bind  = "attrs"
                    v-on    = "on"
                    icon    = "mdi-format-list-bulleted-square"
                    :color  = "valid ? 'success' : 'error'"
                    size    ="23"
                    tooltip = "Mängelliste anzeigen"
                    @click  = "open = !open"
                />
                <!--
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    text
                    style="margin-top: -4px; min-width: 25px; width: 25px; height: 22px"
                >
                    <v-icon size="23" :color="valid ? 'success' : 'error'">mdi-format-list-bulleted-square </v-icon>
                </v-btn>
                -->
            </template>

            <v-card class="white lm-border pa-2" style="width: 400px; min-height: 500px; border-radius: 16px" >
                <v-row
                    dense
                    v-for="(entry, i) in entries" :key="i"
                   class="v-flex pt-1 pb-1 white"
                   :style="i<entries.length-1 ? 'border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: lightgrey' : ''"
                >
                    <v-col class="col-1" style="text-align: center">
                        <v-icon size="20" :color="entry.result === 'ok' ? 'success' : 'error'">{{entry.result === 'ok' ? 'mdi-check' : 'mdi-minus'}} </v-icon>
                    </v-col>
                    <v-col>
                        {{ entry.name }}
                    </v-col>
                </v-row>
            </v-card>
        </v-menu>
    </div>
</template>

<script>

import GuardProtocol from "@/modules/inc/todos/service/GuardProtocol";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";

export default {
    name: "PIncGuardProtocolCheckList",
    components: {CToolbarButton},

    props: {
        customer: {
        },

        protocol: {
        },

        valid: {

        }
    },

    computed: {
    },

    data: () => ({
        entries: [],
        open: false,
    }),

    watch: {
        open () {
            console.log("open")
            if (this.open && this.entries.length === 0) {
                this.load();
            }
        }
    },

    methods: {
        load () {
            console.log("load")

            if (!this.open) {
                return;
            }
            if (!this.protocol) {
                return;
            }

            GuardProtocol.findCheckList(this.protocol).then(data => {
                this.entries = data;
            });
        }
    }
}
</script>

<style scoped>

:deep(.v-btn.v-btn--density-default) {
    height: 22px;
}

</style>